<template lang="pug">
  .kazakhstan
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/kazakhstan-min.png"
      )
      span {{ gettext('Казахстан') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Страна Казахстан, в которой живет эта нация, расположена на территории, по размерам достигающей примерно 1-го миллиона квадратных миль (2 717 300 квадратных километров), и находится в регионе Центральной Азии. Казахстан основался вдоль исторического Шелкового пути, который соединял Европу с Китаем более двух тысяч лет назад.') }}
        p {{ gettext('Территория Казахстана — это горы и степная равнина, а жизнь в степи суровая, с экстремальными температурами и сильными ветрами. Именно эти аспекты повлияли на характер казахов – непривередливый, стойкий, сдержанный и очень гостеприимный.  Казахи, как и многие другие азиатские народы, кочевой народ, который очень близок к животноводству, в особенности лошадям и мелкому рогатому скоту. На протяжении многих лет в Казахстане развивалась отрасль сельского хозяйства, в которой была задействована значительная часть населения.') }}
        p {{ gettext('Так как казахи также известны в истории как бравые воины, их отличительными чертами является дисциплинированность, смелость и выдержка.') }}
        p {{ gettext('Очень много казахов (более 500 тысяч человек по оценкам на 2017 год) работают в России, находя там возможности для лучшего заработка. Есть и другие страны, которые открывают свои двери для казахских мигрантов: Китай, США; а также страны Европы: Чехия, Польша, Германия, Испания и другие. Многие казахи знают русский язык, так как долгое время он преподавался в учебных заведениях и преподается до сих пор, во время СССР он был официальным государственным языком и сегодня остается широко распространенным среди населения. Этот факт облегчает работникам из Казахстана трудоустройство в России и других, частично русскоязычных странах. ') }}
        p {{ gettext('Если говорить о сферах деятельности казахских рабочих, то в России это торговля, ремонт автотранспорта и бытовых приборов, предоставление социальных услуг и сервиса, строительство, транспортный сектор. В страны Европы казахи чаще всего приезжают на сезонную работу в сферах сельского хозяйства, производства и предоставления услуг. Кроме этого, в Казахстане бурно развивается сфера ИТ-технологий, а вместе с ней и технологические навыки её граждан, многие из которых хорошие специалисты в технике и электрике.') }}
        p {{ gettext('Благодаря казахским рабочим, которые в России получают заметно менее высокие заработные платы нежели сами россияне, экономика России получает высокую прибыль. ') }}
        p {{ gettext('Большинство работодателей, у которых работники из Казахстана вели какую-либо трудовую деятельность, характеризируют их как ответственных, скромных, неприхотливых, умеющих прислушиваться и учиться людей. ') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/kazakhstan-min.png'})
  },
  name: 'Kazakhstan',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Kazakhstan | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/kazakhstan/index.vue